import getStrings from "./Translations";

export const getTitle = (metadata) => {
    if (!metadata) return "document";
    const strings = getStrings();
    return metadata.Title?.value ?? metadata.Titel?.value ?? metadata.Name?.value ?? metadata.Namn?.value ?? metadata[strings['Filename']]?.value ?? "document"
}

const assignValue = (e, value, type, keys, key) => {
    const attr = type.fields[key];
    if (key in type.fields) {
      const name = localStorage.getItem('lang') === 'sv' ?
        attr.displayname_sv : attr.displayname;
      keys.add(type.fields[key].name);
      e[name] = { value: value };
      Object.assign(e[name], type.fields[key]);
    }
  }

export const formatMetadata = (doc, type, currIndex) => {
    //TODO: figure out types when not from documentReducer
    let formattedMetadata = {};
    const keys = new Set();
    for (const key in doc.metadata) {
        assignValue(formattedMetadata, doc.metadata[key], type, keys, key);
    }
    for (const key in type.fields) {
        if (!keys.has(key) && type.fields[key].type == "text") {
            assignValue(formattedMetadata, "", type, keys, key);
        }
    }
    const strings = getStrings();
    formattedMetadata[strings['Type']] = { value: doc['type'] };
    formattedMetadata[strings['Creator']] = { value: doc['creator'], type: 'text' };
    formattedMetadata[strings['Created_at']] = { value: doc['ts'], type: 'date' };
    formattedMetadata['Version'] = ('version' in doc) ? { value: doc['version'], type: 'text' } : { value: 1, type: 'text' };
    const fileAttrs = doc['file'];
    if (fileAttrs != null) {
        formattedMetadata[strings['Filename']] = { value: doc['file']['name'], type: 'text' };
        formattedMetadata['Mimetype'] = { value: doc['file']['type'], type: 'text' };
    }
    if ('serialNo' in doc)
        formattedMetadata['Reference'] = { value: doc['serialNo'], type: 'text' };
    if ('lock' in doc)
        formattedMetadata['LockedBy'] = { value: doc['lock']['locked_by'], type: 'text' };
    formattedMetadata['id'] = { value: doc['_id'] };
    formattedMetadata['_isEditable'] = { value: doc.metadata.isEditable ? doc.metadata.isEditable : false };
    formattedMetadata['_index'] = { value: currIndex };
    formattedMetadata['_audit'] = { value: doc['audit'] };
    return formattedMetadata;
};
